import { config } from '@/config';
import type { AiGroupSuggestionsResponse, TagGroupSuggestion } from '../types';

export const fetchAiGroupSuggestions = async (
  token: string,
  tags: string[],
  tagCounts: Record<string, number>,
): Promise<TagGroupSuggestion[]> => {
  const response = await fetch(`${config.apiUrl}/tags/ai-group-suggestions`, {
    method: 'POST',
    headers: {
      authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    },
    body: JSON.stringify({ tags, tag_counts: tagCounts }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error((errorData as Record<string, string>).detail || 'Request failed');
  }

  const result = (await response.json()) as AiGroupSuggestionsResponse;
  return result.suggestions;
};
